// extracted by mini-css-extract-plugin
module.exports = {"redArrow":"WhatYouWillLearn_redArrow__walkj"};